import React, { useState } from 'react';
import ModalComponent from '../../../components/modal/modal';
import ModalBody from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';

interface VoidDoneTradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  row: Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto | null;
  onConfirmVoid: (tradeOrderId: string, reason: string) => void;
  isLoading: boolean;
}

const VoidDoneTradeModal: React.FC<VoidDoneTradeModalProps> = ({
  isOpen,
  onClose,
  row,
  onConfirmVoid,
  isLoading,
}) => {
  const [reason, setReason] = useState('');

  const handleSubmit = () => {
    if (!row || !reason.trim()) return;
    onConfirmVoid(row.tradeOrderId as unknown as string, reason.trim());
  };

  if (!row) return null;

  return (
    <ModalComponent
      show={isOpen}
      closeModal={onClose}
      title='Void Done Trade'
      size='lg'
      id='voidDoneTradeModal'
    >
      <div>
        <ModalBody>
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: '6px', padding: '12px 16px', marginBottom: '16px' }}>
            <strong style={{ color: '#991b1b' }}>Warning:</strong>
            <span style={{ color: '#7f1d1d', marginLeft: '6px' }}>
              This will reverse the ledger entries for this Done Trade. This action cannot be undone.
            </span>
          </div>

          <div style={{ background: '#f3f4f6', borderRadius: '6px', padding: '12px 16px', marginBottom: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>
              {row.shares} shares of {row.recordType || 'Unknown'} &mdash;{' '}
              {row.bookingType === 'Done Trade' ? 'Done Trade' : row.bookingType} &mdash;{' '}
              Executed {row.orderExecutionDate
                ? new Date(row.orderExecutionDate).toLocaleDateString()
                : 'N/A'}
            </div>
          </div>

          <div style={{ marginBottom: '8px' }}>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '6px', textTransform: 'uppercase' }}>
              Reason for Void (Required)
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder='Enter the reason for voiding this trade...'
              rows={4}
              maxLength={500}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '13px',
                resize: 'vertical',
              }}
            />
            <div style={{ fontSize: '11px', color: '#9ca3af', textAlign: 'right', marginTop: '4px' }}>
              {reason.length}/500
            </div>
          </div>
        </ModalBody>
        <ModalFooterComponent
          modalStatus='Add'
          onCloseModal={onClose}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          addTitle=''
          buttonTitle={isLoading ? 'Voiding...' : 'Confirm Void'}
          onClickButton={handleSubmit}
          checkError={!reason.trim()}
          id='voidDoneTradeFooter'
        />
      </div>
    </ModalComponent>
  );
};

export default VoidDoneTradeModal;
